import React from "react";
import { OnboardingQuestion } from "../../models/OnboardingFlow";
import {BCIcon, getIconFromString, ICONS} from "../generic/BCIcons";
import {OnboardingAnswerButton} from "../generic/BCButtons";

interface OnboardingQuestionProps {
    question: OnboardingQuestion;
    setNextDisabled: (disabled: boolean) => void;
}

export const OnboardingQuestionV2: React.FC<OnboardingQuestionProps> = ({
                                                                          question,
                                                                          setNextDisabled
                                                                      }) => {
    const [selectedAnswer, setSelectedAnswer] = React.useState<number | null>(null);

    const onAnswerSelected = (answerId: number) => {
        // setUserAnswers(prevAnswers => {
        //     const updatedAnswers = [...prevAnswers];
        //     updatedAnswers[currentQuestionnaireIndex] = answerId;
        //     return updatedAnswers;
        // });
        setNextDisabled(false);
        setSelectedAnswer(answerId);
    };

    return (
        <div className="onboarding-buttons-container">
            {question.answers.map(({ id, text, icon }) => {
                const isSelected = selectedAnswer === id;
                const iconComponent = getIconFromString(icon);
                return (
                    <OnboardingAnswerButton text={text} iconLeft={iconComponent} isSelected={isSelected} onClick={() => onAnswerSelected(id)}/>
                );
            })}
        </div>
    );
};